import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from './services/auth/auth.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, OnDestroy {
  title = 'dream';
  navActive = true;

  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute) { 

      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        this.navActive = !['/login', '/communityx', '/share'].includes(event.url); // Adjust paths as needed
      });
    }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.authService.ngOnDestroy();
  }

}
